import { render, staticRenderFns } from "./NewOpportunity.vue?vue&type=template&id=6e1d95f4&"
import script from "./NewOpportunity.vue?vue&type=script&lang=js&"
export * from "./NewOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./NewOpportunity.vue?vue&type=style&index=0&id=6e1d95f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports